module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('p', [_vm._v("\n        セット名（英語）、セット名（日本語）、作成者、フィガーを入力してください。「*(アスタリスク)」が付いている項目は必須項目です。\n      ")]), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.setNameError),
      expression: "!setNameError"
    }],
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("セット名（英語）")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.setName),
      callback: function($$v) {
        _vm.setName = $$v
      },
      expression: "setName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.setNameError),
      expression: "setNameError"
    }],
    staticClass: "md-input-invalid",
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("セット名（英語）")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.setName),
      callback: function($$v) {
        _vm.setName = $$v
      },
      expression: "setName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error",
    model: {
      value: (_vm.setNameError),
      callback: function($$v) {
        _vm.setNameError = $$v
      },
      expression: "setNameError"
    }
  }, [_vm._v(_vm._s(_vm.setNameError))])], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.setNameJPError),
      expression: "!setNameJPError"
    }],
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("セット名（日本語）")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.setNameJP),
      callback: function($$v) {
        _vm.setNameJP = $$v
      },
      expression: "setNameJP"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.setNameJPError),
      expression: "setNameJPError"
    }],
    staticClass: "md-input-invalid",
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("セット名（日本語）")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.setNameJP),
      callback: function($$v) {
        _vm.setNameJP = $$v
      },
      expression: "setNameJP"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error",
    model: {
      value: (_vm.setNameJPError),
      callback: function($$v) {
        _vm.setNameJPError = $$v
      },
      expression: "setNameJPError"
    }
  }, [_vm._v(_vm._s(_vm.setNameJPError))])], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editerNameError),
      expression: "!editerNameError"
    }],
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("作成者")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.editerName),
      callback: function($$v) {
        _vm.editerName = $$v
      },
      expression: "editerName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editerNameError),
      expression: "editerNameError"
    }],
    staticClass: "md-input-invalid",
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("作成者")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.editerName),
      callback: function($$v) {
        _vm.editerName = $$v
      },
      expression: "editerName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error",
    model: {
      value: (_vm.editerNameError),
      callback: function($$v) {
        _vm.editerNameError = $$v
      },
      expression: "editerNameError"
    }
  }, [_vm._v(_vm._s(_vm.editerNameError))])], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("セットの説明")]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.notices),
      callback: function($$v) {
        _vm.notices = $$v
      },
      expression: "notices"
    }
  })], 1), _vm._v(" "), _c('div', [_c('md-radio', {
    attrs: {
      "id": "my-test1",
      "name": "type-of-evnet",
      "md-value": "Class"
    },
    model: {
      value: (_vm.typeOfEvnet),
      callback: function($$v) {
        _vm.typeOfEvnet = $$v
      },
      expression: "typeOfEvnet"
    }
  }, [_vm._v("クラス")]), _vm._v(" "), _c('md-radio', {
    attrs: {
      "id": "my-test2",
      "name": "type-of-evnet",
      "md-value": "Céilí"
    },
    model: {
      value: (_vm.typeOfEvnet),
      callback: function($$v) {
        _vm.typeOfEvnet = $$v
      },
      expression: "typeOfEvnet"
    }
  }, [_vm._v("ケーリー")]), _vm._v(" "), _c('md-radio', {
    attrs: {
      "id": "my-test2",
      "name": "type-of-evnet",
      "md-value": "SessionOrDance"
    },
    model: {
      value: (_vm.typeOfEvnet),
      callback: function($$v) {
        _vm.typeOfEvnet = $$v
      },
      expression: "typeOfEvnet"
    }
  }, [_vm._v("セッション/ダンス")])], 1)], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "id": "addEvent"
    },
    on: {
      "click": function($event) {
        _vm.setEvent('dialog5')
      }
    }
  }, [_vm._v("セットを作成する")])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "dialog5",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirm.contentHtml,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.openErrorConsole($event)
      }
    }
  }, [_c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": 'top center',
      "md-duration": 4000
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2756874c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddSet.vue
// module id = 332
// module chunks = 1